// https://github.com/mitchellhamilton/apply-ref
import { Ref } from 'react';

const apply = <T>(ref: Ref<T>, value: T | null): void => {
  if (typeof ref === 'object' && ref !== null) {
    // @ts-ignore
    ref.current = value;
  }
  if (typeof ref === 'function') {
    ref(value);
  }
};

export const applyRefs = <T>(...refs: Ref<T>[]) => (value: T | null): void => {
  refs.forEach((ref) => apply(ref, value));
};

export default apply;
